import * as ko from "knockout";
import { NewestPdf } from "../Models/Pdf/NewestPdf";
import "footable-npm";

export class LatestDocumentsViewModel {
    latestDocuments = ko.observableArray<NewestPdf>();
    allDocuments = ko.observableArray<NewestPdf>();
    isLoading = ko.observable<boolean>(true);
    expanded = ko.observable<boolean>(true);
    footableLoaded = false;

    showMore(): void {
        this.expanded(true);

        if (!this.footableLoaded) {
            
            this.footableLoaded = true;
        }
    }

    showLess(): void {
        this.expanded(false);
    }
}